export default "__VITE_ASSET__472a517f__"